import { defineStore } from 'pinia';

export enum ProcessTriggerEditType {
    ProcessTrigger
}
export interface ProcessTriggerEditStoreState {
    create?: {
        type?: ProcessTriggerEditType;
    };
    edit?: {
        key?: number;
        type?: ProcessTriggerEditType;
    };
}

export const useProcessTriggerEditStore = defineStore('configuration-process-trigger-edit-store', {
    state: (): ProcessTriggerEditStoreState => ({
        create: null,
        edit: null,
    }),
    getters: {
        isCreate(): (type: ProcessTriggerEditType) => boolean {
            return (type: ProcessTriggerEditType) => this.create?.type === type;
        },
        creating(): boolean {
            return this.create !== null && this.create?.type !== null;
        },
        isEdit(): (type: ProcessTriggerEditType, id: number) => boolean {
            return (type: ProcessTriggerEditType, id: number) => this.edit?.type === type && this.edit?.key === id;
        },
        editing(): boolean {
            return this.edit !== null && this.edit?.type !== null && this.edit?.key !== null;
        },
    },
    actions: {
        openCreate(type: ProcessTriggerEditType) {
            this.create = { type };
            this.edit = null;
        },
        closeCreate() {
            this.create = null;
        },
        openEdit(type: ProcessTriggerEditType, key: number) {
            this.edit = { type, key };
            this.create = null;
        },
        closeEdit() {
            this.edit = null;
        },
    },
});
